<template>
    <div class="d-flex align-items-center">
        <div
            v-if="
                isLoading === false &&
                    verifiedConnections().length === 0 &&
                    badgePrompt
            "
        >
            <StatusIndicator
                v-if="data().length === 0"
                @click.native="() => showUniversity(null)"
            />
        </div>
        <transition name="slide" mode="out-in">
            <div v-if="data().length > 0" class="d-flex align-items-center">
                <div
                    v-if="badgePrompt && unverifiedConnections().length === 0"
                    v-b-tooltip.hover
                    class="add-btn d-flex align-items-center justify-content-center pointer overlap"
                    :title="$t('shared.universityBadges.addAnotherUniversity')"
                    @click="openUniversityVerifyModule"
                >
                    <BaseIcon class="plus-icon" name="plus" size="lg" />
                </div>
                <UniversityAvatar
                    v-for="c in data()"
                    :key="c.id"
                    :connection="c"
                    class="overlap"
                    @click.native="() => showUniversity(c)"
                />
            </div>
        </transition>
        <transition name="vertical-slide" mode="out-in">
            <VerificationDialog
                v-if="showVerificationDialog"
                :connection="selectedUniConnection"
                v-on:close="toggleVerificationDialog"
                v-on:update="updateConnections"
            />
        </transition>
    </div>
</template>

<script>
// Component specific components
import UniversityAvatar from './UniversityAvatar';
import VerificationDialog from './dialogs/VerificationDialog';
import StatusIndicator from './StatusIndicator';

// Utils
import DialogService from '~/services/DialogService';
import { getSubDomain } from '~/utils/urlUtils';
import { REQUIRE_VERIFICATION_BADGE_PROMPT } from '~/router';

export default {
    name: 'UniversityBadges',
    components: { UniversityAvatar, VerificationDialog, StatusIndicator },
    data: () => ({
        isLoading: true,
        forceUpdate: false,
        badgePrompt: REQUIRE_VERIFICATION_BADGE_PROMPT,
    }),
    computed: {
        connections() {
            let shouldUpdate = this.forceUpdate === true;
            const connections = this.$interfaces.university.connection.get({
                reactive: true,
                forceUpdate: shouldUpdate,
            });
            this.forceUpdate = false;
            return connections;
        },
        showVerificationDialog() {
            return this.$interfaces.uniBadgeModule.isOpen();
        },
        selectedUniConnection() {
            return this.$interfaces.uniBadgeModule.getSelected();
        },
    },
    methods: {
        currentUniversityVerified() {
            const currentUni = getSubDomain();
            if (!currentUni) {
                return true;
            }
            return (
                this.data().filter(
                    c => (c.subDomain || '').toLowerCase() === currentUni
                ).length > 0
            );
        },
        data() {
            return this.connections.data || [];
        },
        verifiedConnections() {
            return this.data().filter(c => c.isVerified === true);
        },
        unverifiedConnections() {
            return this.data().filter(c => c.isVerified === false);
        },
        openUniversityVerifyModule() {
            DialogService.openUniVerifyDialog();
        },
        toggleVerificationDialog() {
            this.$interfaces.uniBadgeModule.setOpen(
                !this.$interfaces.uniBadgeModule.isOpen()
            );
        },
        showUniversity(uniConnection) {
            this.$interfaces.uniBadgeModule.setOpenAndSelected({
                isOpen: true,
                selected: uniConnection,
            });
        },
        updateConnections(value) {
            this.forceUpdate = value;
        },
    },
    watch: {
        connections() {
            this.isLoading = false;
        },
    },
};
</script>

<style scoped>
/* Avatar */
.overlap {
    margin-left: -10px;
    transition: all 0.3s ease-out;
}
.overlap:hover {
    z-index: 200;
    transform: scale(1.1);
    margin: 0 2px;
}

/* Add Btn */
.add-btn {
    box-sizing: border-box;
    border-radius: 50%;
    background-color: rgb(224, 224, 224);

    width: 36px;
    height: 36px;
}
.plus-icon {
    color: rgba(0, 0, 0, 0.2);
}
</style>
